export default "__VITE_ASSET__cHG94Kxl__"